import { assign, validString } from "../../helper.js";
import { BracketTypeList, CANVAS_SIZE_MAX, CANVAS_SIZE_MIN, CANVAS_ZOOM_MIN, CanvasTypeList, ColumnTypeList, DatabaseList, HighlightThemeList, LanguageList, NameCaseList } from "../schema/canvasEntity.js";
import { clamp, difference, isBoolean, isNil, isNumber, isPlainObject, isString } from "es-toolkit";
//#region ../erd-editor-schema/dist/v2/parser/canvas.js
var createCanvasEntity = () => ({
	version: "2.2.11",
	width: 2e3,
	height: 2e3,
	scrollTop: 0,
	scrollLeft: 0,
	zoomLevel: 1,
	show: {
		tableComment: true,
		columnComment: true,
		columnDataType: true,
		columnDefault: true,
		columnAutoIncrement: false,
		columnPrimaryKey: true,
		columnUnique: false,
		columnNotNull: true,
		relationship: true
	},
	database: "MySQL",
	databaseName: "",
	canvasType: "ERD",
	language: "GraphQL",
	tableCase: "pascalCase",
	columnCase: "camelCase",
	highlightTheme: "VS2015",
	bracketType: "none",
	setting: {
		relationshipDataTypeSync: true,
		relationshipOptimization: false,
		columnOrder: [
			"columnName",
			"columnDataType",
			"columnNotNull",
			"columnUnique",
			"columnAutoIncrement",
			"columnDefault",
			"columnComment"
		]
	},
	pluginSerializationMap: {}
});
var sizeInRange = (value) => clamp(value, CANVAS_SIZE_MIN, CANVAS_SIZE_MAX);
var zoomInRange = (value) => clamp(value, CANVAS_ZOOM_MIN, 1);
function createAndMergeCanvasEntity(json) {
	const entity = createCanvasEntity();
	if (isNil(json)) return entity;
	const assignNumber = assign(isNumber, entity, json);
	const assignString = assign(isString, entity, json);
	const showAssignBoolean = assign(isBoolean, entity.show, json.show);
	const settingAssignBoolean = assign(isBoolean, entity.setting, json.setting);
	if (isNumber(json.width)) entity.width = sizeInRange(json.width);
	if (isNumber(json.height)) entity.height = sizeInRange(json.height);
	if (isNumber(json.zoomLevel)) entity.zoomLevel = zoomInRange(json.zoomLevel);
	assignString("version");
	assignString("databaseName");
	assignNumber("scrollTop");
	assignNumber("scrollLeft");
	assign(validString(DatabaseList), entity, json)("database");
	assign(validString(CanvasTypeList), entity, json)("canvasType");
	assign(validString(LanguageList), entity, json)("language");
	assign(validString(NameCaseList), entity, json)("tableCase");
	assign(validString(NameCaseList), entity, json)("columnCase");
	assign(validString(HighlightThemeList), entity, json)("highlightTheme");
	assign(validString(BracketTypeList), entity, json)("bracketType");
	showAssignBoolean("tableComment");
	showAssignBoolean("columnComment");
	showAssignBoolean("columnDataType");
	showAssignBoolean("columnDefault");
	showAssignBoolean("columnAutoIncrement");
	showAssignBoolean("columnPrimaryKey");
	showAssignBoolean("columnUnique");
	showAssignBoolean("columnNotNull");
	showAssignBoolean("relationship");
	settingAssignBoolean("relationshipDataTypeSync");
	settingAssignBoolean("relationshipOptimization");
	if (json.setting?.columnOrder && ColumnTypeList.length === json.setting.columnOrder.length && difference(ColumnTypeList, json.setting.columnOrder).length === 0) entity.setting.columnOrder = json.setting.columnOrder;
	if (isPlainObject(json.pluginSerializationMap)) {
		const pluginSerializationMap = json.pluginSerializationMap;
		for (const key of Object.keys(pluginSerializationMap)) {
			const value = pluginSerializationMap[key];
			if (isString(value)) entity.pluginSerializationMap[key] = value;
		}
	}
	return entity;
}
//#endregion
export { createAndMergeCanvasEntity };
